/* tslint:disable */
/* eslint-disable */

/**
 * Voucher type
 */
export enum VoucherType {
  EuropeUpgrade = 'EUROPE_UPGRADE',
  LongHaulUpgrade = 'LONG_HAUL_UPGRADE',
  UpgradeBenefit = 'UPGRADE_BENEFIT'
}
